module.exports = __webpack_public_path__ + "img/job-description-outline.171f9dfc.svg";